enum ToggleStyle {
  SWITCH = 'switch',
  INDIVIDUAL = 'individual',
  TABS = 'tabs',
}
export { ToggleStyle };
